import React from 'react'
import { HorizontalCricketWidget } from './HorizontalCricketWidget'
import { Box } from '../../../compositions/Box/Box'
import { createRegisterableComponent } from '@news-mono/web-common'
import { ThemeMargins } from '../../../__styling/settings/metrics'

interface Props {
    verticalSpacing?: keyof ThemeMargins
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
}

export const HorizontalCricketWidgetRegistration = createRegisterableComponent(
    'HorizontalCricketWidget',
    (props: Props) => {
        return (
            <Box {...props}>
                <HorizontalCricketWidget />
            </Box>
        )
    },
)
